export default __webpack_public_path__ + "static/media/programa-pacientes.6dd3384d.svg";